/* import __COLOCATED_TEMPLATE__ from './footer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./footer.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());